export default {
  props: {
    value: {
      default: ''
    },
    opacity: {
      default: true
    }
  },
  data: function data() {
    return {};
  },
  computed: {
    tagStyle: function tagStyle() {
      var style = {};
      if (this.opacity) {
        style = {
          borderRadius: '3px',
          color: this.value === '次日发货' ? '#FFA800' : '#F15820',
          background: this.value === '次日发货' ? 'rgba(255, 227, 189, 0.5)' : 'rgba(241, 200, 185, 0.5)'
        };
      } else if (this.value === '次日发货') {
        style = {
          background: '#ffa800'
        };
      }
      style.padding = '4px 8px';
      return style;
    }
  }
};